export default __webpack_public_path__ + "static/media/grey-radio.745d3e5c.svg";